<template>
  <div class="logo-wrap">
      <img :src="logoUrl" alt="logo" class="logo">
      <span class="text">中国土木工程学会</span>
  </div>
</template>

<script>
export default {
    props: {
        logoUrl: {
            type: String,
            default: require('@assets/img/logo-header.png')
        }
    }
}
</script>

<style lang="scss" scoped>
.logo-wrap {
    position: relative;
    display: table;
    height: 100%;

    .logo {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }

    .text {
        padding-left: 95px;
        display: table-cell;
        font-size: 24px;
        color: #424242;
        vertical-align: middle;
    }
}
</style>